import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import {
  BreadcrumbsItem as FEFBreadcrumbsItem,
} from '4ff-lib-foundation/lib/AppFrame/publicAPI/components';
import { getFieldFromMeta } from '4ff-lib-foundation/lib/AppFrame/publicAPI/config';
import { getAppconfig } from '4ff-lib-foundation/lib/AppFrame/publicAPI/store';

const appPrefix = getFieldFromMeta('appPrefix');

const BreadcrumbsItem = ({ to, weight, children, ...rest }) => {
  const history = useHistory();
  const config = getAppconfig();
  const navigateTo = path => {
    const normalizedPath = path.replace(appPrefix, '');
    if (config?.breadcrumbsReload) {
      window.location.href = normalizedPath;
    } else {
      history.push(normalizedPath);
    }
  };

  return (
    <FEFBreadcrumbsItem to={to} onClick={navigateTo} weight={weight} {...rest}>
      {children}
    </FEFBreadcrumbsItem>
  );
};

BreadcrumbsItem.propTypes = {
  to: PropTypes.string.isRequired,
  weight: PropTypes.number,
  children: PropTypes.node.isRequired,
};

BreadcrumbsItem.defaultProps = {
  weight: 100,
};

export default BreadcrumbsItem;
